
import { createBreakpoint } from 'react-use';
import { defaultBreakpoints } from '../settings/default-breakpoints';

export const useBreakpoint = createBreakpoint(defaultBreakpoints); 